import { Component, computed, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { IWidgetExceptionalCaseInformation } from 'scw-digital-boards-widgets';

@Component({
  imports: [MatIcon],
  selector: 'widget-exceptional-case-information',
  standalone: true,
  styleUrls: ['./widget-exceptional-case-information.component.scss'],
  templateUrl: './widget-exceptional-case-information.component.html',
})
export class WidgetExceptionalCaseInformationComponent {
  public data = input.required<IWidgetExceptionalCaseInformation[]>();

  public readonly shownMessage = computed(() => (this.data()?.length ? this.data()[0] : null));
}
